import React, { Component } from "react";
import Dropzone from "react-dropzone";
import axios from 'axios';

export default class DragNDropComponent extends Component {

  state = {
    imageFiles: null,
    resData: [],
    resDataClarifia: [],
    uploadedImageName : null
  }

  
  onDrop = (acceptedFiles, rejectedFiles) => {

    this.setState({imageFiles: acceptedFiles})
    console.log(acceptedFiles)
    const fd = new FormData();

    acceptedFiles.forEach(file => {
      fd.append('file', file, file.name);
    });
    

    var config = { crossdomain: true };
    axios.post('https://php7.virtinalabs.net/demovisualsearch/v1/image-upload.php', fd,config
    ).then(res=>
      {
            console.log(res);
            this.setState({

              resData: res.data.map( obj => {
                                            
                this.searchForMatch(obj.image_name);
            })
           
         });
     
      }
    );
  }

  searchForMatch(uploadedImageName){
    console.log("searchForMatch func Image name: "+uploadedImageName);
    var config = { crossdomain: true };
     
    const formData = new FormData();
    formData.append("image_url","http://php7.virtinalabs.net/demovisualsearch/v1/uploads/"+uploadedImageName)
    
    axios.post('https://php7.virtinalabs.net/clarifai/index.php', formData,config
    ).then(res=>
      {
        console.log("Clarifia result: ",res.data);

            this.setState({

              resDataClarifia: res.data.response.map( obj => {
                                   
                console.log("Clarifia result img: "+obj.image_url);
                console.log("Clarifia result score: "+obj.score);
            })
           
         });
              
      }
    );
}

 
  render() {

    const baseStyle = {
      width: '70%',
      height: '70%',
      borderWidth: 2,
      borderColor: '#666',
      borderStyle: 'dashed',
      borderRadius: 5,
      backgroundColor:'#b2d8d8',
      position:'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      textAlign: 'middle'
    };
    const activeStyle = {
      borderStyle: 'solid',
      borderColor: '#6c6',
      backgroundColor: '#eee'
    };
    const rejectStyle = {
      borderStyle: 'solid',
      borderColor: '#c66',
      backgroundColor: '#eee'
    };
      
    return (
      <Dropzone onDrop={this.onDrop}
      accept="image/*"
      multiple={false}>
      {({getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject, acceptedFiles, rejectedFiles}) => {
        let styles = {...baseStyle}
        styles = isDragActive ? {...styles, ...activeStyle} : styles
        styles = isDragReject ? {...styles, ...rejectStyle} : styles

        return (
          <div
            {...getRootProps()}
            style={styles}>
            <input {...getInputProps()}/>
            {
              isDragActive ?
                <p>Drop image here...</p> :
                <p>Try dropping some image here or click to select image to upload.</p>
            }

            {
              isDragReject && <div>Unsupported file type...</div>
            } 

            {
              isDragAccept && <div>File accepted...</div>
            }   
          </div>
                    
        )
      }}
    </Dropzone>
    
    );
  }
}


